import { produce } from 'immer';

import { ActionType } from 'app/store/actionTypes';
import { PriceBeforeRecalculationActionsType } from './actions';
import { PriceBeforeRecalculationState } from './state.interface';

const initialState: PriceBeforeRecalculationState = {
  oneTime: null,
  installments: {},
};

const priceBeforeRecalculationReducer = (
  state: PriceBeforeRecalculationState = initialState,
  action: PriceBeforeRecalculationActionsType
) =>
  produce(state, (draft) => {
    switch (action.type) {
      case ActionType.SET_PRICE_BEFORE_RECALCULATION:
        draft.oneTime = action.payload.oneTime;
        draft.installments = action.payload.installments;
        return;
      case ActionType.CLEAR_PRICE_BEFORE_RECALCULATION:
        draft.oneTime = null;
        draft.installments = {};
        return;
      default:
        return state;
    }
  });

export default priceBeforeRecalculationReducer;
